import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/asset-wise/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

export const getExecutives = (params) => instance().get('/executive/all', { params })

export const createExecutive = (data) => instance().post('/executive/create', data)

export const updateExecutive = (data) => instance().put('/executive/edit', data)

export const deleteExecutive = (data) => instance().post('/executive/delete', data)

export const getBrokers = (data) => instance().post('/broker/list', data)

export const getTeams = (data) => instance().post('/team/filter', data)

export const disconnectBroker = (data) => instance().post('/broker/disconnect', data)

export const getLandSales = (data) => instance().post('/land-sale', data)

export const getProvinces = (params) => instance().get('/province/filter', { params })

export const getDistricts = (params) => instance().get('/district/filter', { params })

export const getSubdistricts = (params) => instance().get('/sub-district/filter', { params })

export const getLandRecords = (data) => instance().post('/land-records', data)

export const getLandSaleStatuses = (params) => instance().get('/land/sale-status', { params })

export const getBroadcasts = (params) => instance().get('/executive/broadcast', { params })

export const createBroadcast = (data) => instance().post('/executive/broadcast', data)

export const editBroadcast = (data) => instance().put('/executive/broadcast', data)

export const deleteBroadcast = (params) => instance().delete('/executive/broadcast', { params })

export const getUsers = (data) => instance().post('/user/filter', data)



// WEBPACK FOOTER //
// ./src/api/assetwise.js